// import { useState } from 'react';
import Footer from './new_comps/Footer';
import Header from './new_comps/Header';
import Routes from './new_comps/Routes';
import { singles as s, albums as a } from './new_comps/modules/Arrays';

function A() {
  // const [albums, setAlbums] = useState(a);
  // const [singles, setSingles] = useState(s);
  let albumList = [], check = [];
    a.forEach(album => {
      if(!check.includes(album.album)){
        let al = {id: album.id, title: album.album, artist: album.artist, cover: album.cover, url: "/"+album.album.replace(/ /g, "-")};
        albumList.push(al);
        check.push(album.album);
      }
  });
  return (
    <>

      <Header />
      <Routes albums={albumList} singles={s} />
      <Footer />
    </>
  );
}

export default A;